import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from "../contexts/auth";
import { updateProfile, whoami } from '../services/api';
import Swal from 'sweetalert2';
import { getCitiesList } from '../services/api_resources';
import ComboboxAutocompleteAPI from './combobox_autocomplete_api';


function EditProfileForm({ data, token, close, refresh }) {
  const { setProfile } = useContext(AuthContext)

  // Define default values for the form fields
  const defaultValues = {
    business_name: data?.profile?.business_name || '',
    email: data?.profile?.email || '',
    pec: data?.profile?.pec || '',
    address: data?.profile?.address || '',
    cap: data?.profile?.cap || '',
    city: data?.profile?.city || null,
    city_name: data?.profile?.city_name || '',
    logo_url: data?.profile?.logo_url || '',
    piva: data?.profile?.piva || '',
    cf : data?.profile?.cf || '',
    external_reference : data?.profile?.external_reference || '',
  };

  // Initialize state with default values
  const [formData, setFormData] = useState(defaultValues);
  const [logoFile, setLogoFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [clearLogo, setClearLogo] = useState(false);
 
  
  // Handler to update the state when an input field is changed
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  }

  const handleCityChange = (cityObj) => {
    if (!cityObj) {
      setFormData((prev) => ({
        ...prev,
        city: null,
        city_name: '',
      }));
      return;
    }
  
    setFormData((prev) => ({
      ...prev,
      city: cityObj.id,
      city_name: cityObj.name,
    }));
  };
 

  const handleFileChange = (e) => {
    setLogoFile(e.target.files[0]);
  }

  const handleCheckboxChange = (e) => {
    setClearLogo(e.target.checked);
  };

  // FUNZIONE PRECEDENTE DI SALVATAGGIO, LASCIO COMMENTATA
  
  // Handler for form submission
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // Do something with the formData (e.g., send to server, display on UI, etc.)
  //   console.log(formData);
  //   updateProfile(token, formData).then((res) => {
  //     Swal.fire(
  //       'Profilo aggiornato con successo!',
  //       'Alcuni cambiamenti verranno visualizzati al prossimo accesso.',
  //       'success'
  //     )
  //     close()
  //     refresh(formData)
  //   }).catch((err) => {
  //     console.log(err)
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Oops... qualcosa è andato storto!',
  //       text: err.message,
  //     })
  //   })
  // }

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Mostra il caricamento
    Swal.fire({
      title: 'Salvaggio in corso...',
      text: 'Attendere per favore',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  
    try {
      // Crea un oggetto FormData per gestire i file caricati
      const formDataToSend = new FormData();
  
      // Aggiungi i dati del modulo a FormData
      Object.keys(formData).forEach(key => {
        if (key !== 'logo_url') {
          formDataToSend.append(key, formData[key]);
        }
      });
  
      if (logoFile) {
        formDataToSend.append('logo_url', logoFile);
      } else if (clearLogo) {
        formDataToSend.append('logo_url', null);
      }

      // Invia i dati al server
      await updateProfile(token, formDataToSend);
  
      // Dopo l'aggiornamento, effettua una richiesta a /me per ottenere i dati aggiornati
      if (token) {
        setLoading(true);
        setError('');
  
        const updatedProfileResponse = await whoami(token);
  
        // Aggiorna il contesto globale con i nuovi dati
        setProfile(updatedProfileResponse);
  
        // Chiama la funzione di refresh per aggiornare il componente padre
        refresh(updatedProfileResponse);
  
        setLoading(false);
  
        Swal.fire(
          'Salvato!',
          'Profilo aggiornato con successo',
          'success'
        );
  
        close();
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: 'error',
        title: 'Oops... qualcosa è andato storto!',
        text: err.message,
      });
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className="p-4">
      <div className="mb-4">
        <label htmlFor="business_name" className="block text-sm font-medium text-gray-700">Nome</label>
        <input
          type="text"
          name="business_name"
          id="business_name"
          value={formData.business_name}
          onChange={handleChange}
          className="mt-1 p-2 w-full border rounded-md"
        />
      </div>

      <div className="mb-4">
        <label htmlFor="piva" className="block text-sm font-medium text-gray-700">Partita IVA</label>
        <input
          type="text"
          name="piva"
          id="piva"
          value={formData.piva}
          onChange={handleChange}
          className="mt-1 p-2 w-full border rounded-md"
        />
      </div>

      <div className="mb-4">
        <label htmlFor="cf" className="block text-sm font-medium text-gray-700">Codice Fiscale</label>
        <input
          type="text"
          name="cf"
          id="cf"
          value={formData.cf}
          onChange={handleChange}
          className="mt-1 p-2 w-full border rounded-md"
        />
      </div>

      {/* Email Input Field */}
      <div className="mb-4">
        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
        {/* <input
          type="email"
          name="email"
          id="email"
          value={formData.email}
          onChange={handleChange}
          className="mt-1 p-2 w-full border rounded-md"
        /> */}
        <p className="mt-1 p-2 w-full border rounded-md">{data.company.email}</p>
      </div>

      {/* PEC Input Field */}
      <div className="mb-4">
        <label htmlFor="pec" className="block text-sm font-medium text-gray-700">PEC</label>
        <input
          type="text"
          name="pec"
          id="pec"
          value={formData.pec}
          onChange={handleChange}
          className="mt-1 p-2 w-full border rounded-md"
        />
      </div>

      {/* Address Input Field */}
      <div className="mb-4">
        <label htmlFor="address" className="block text-sm font-medium text-gray-700">Indirizzo</label>
        <input
          type="text"
          name="address"
          id="address"
          value={formData.address}
          onChange={handleChange}
          className="mt-1 p-2 w-full border rounded-md"
        />
      </div>

      <div className="mb-4">
        <label htmlFor="cap" className="block text-sm font-medium text-gray-700">CAP</label>
        <input
          type="text"
          name="cap"
          id="cap"
          value={formData.cap}
          onChange={handleChange}
          className="mt-1 p-2 w-full border rounded-md"
        />
      </div>

      <div className="mb-4">
        <label htmlFor="city_name" className="block text-sm font-medium text-gray-700">Città</label>
          <div className='border border-gray-500 rounded-md'>
            <ComboboxAutocompleteAPI
              getData={(query) => getCitiesList(token, query)}
              getDisplay={(res) => `${res?.name}`}
              getId={(res) => res?.id}
              onChange={handleCityChange}
              currentValue={
                formData.city && formData.city_name
                  ? { id: formData.city, name: formData.city_name }
                  : null
              }
            />

        </div>
      </div>

      <div className="mb-4">
        <label htmlFor="external_reference" className="block text-sm font-medium text-gray-700">ID Gestionale Esterno</label>
        <input
          type="text"
          name="external_reference"
          id="external_reference"
          value={formData.external_reference}
          onChange={handleChange}
          className="mt-1 p-2 w-full border rounded-md"
        />
      </div>

      <div className="mb-4">
        <label htmlFor="logo_url" className="block text-sm font-medium text-gray-700">Logo (carica un file immagine)</label>
        <input
          type="file"
          name="logo_url"
          id="logo_url"
          onChange={handleFileChange}
          className="mt-1 p-2 w-full border rounded-md"
        />
      </div>

      <div className="mb-4">
        <input
          type="checkbox"
          id="clear_logo"
          name="clear_logo"
          checked={clearLogo}
          onChange={handleCheckboxChange}
          className="mr-2"
        />
        <label htmlFor="clear_logo" className="text-sm font-medium text-gray-700">Elimina logo</label>
      </div>

      <span className="isolate inline-flex rounded-md w-full justify-between">
        <button
          type="button"
          className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          onClick={() => close()}
        >
          Annulla
        </button>
        <button
          className="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Salva le modifiche
        </button>
      </span>
    </form>
  );
}

export default EditProfileForm;